import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { getSmsHref, handleSmsClick } from "@/lib/contact";

const ABOUT_IMG = "/images/car-hero.webp";

export const About = () => (
  <section id="o-nas" data-testid="about-section" className="mx-auto max-w-7xl px-5 py-24 md:px-8 md:py-36">
    <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-20">
      <motion.div
        initial={{ opacity: 0, x: -40 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="relative"
      >
        <div className="overflow-hidden rounded-2xl border border-white/10">
          <img
            src={ABOUT_IMG}
            alt="Samochód firmy TRANSPORT OSÓB — komfortowy SUV"
            className="aspect-[4/5] w-full object-cover transition-transform duration-700 hover:scale-105 sm:aspect-[5/4] lg:aspect-[4/5]"
          />
        </div>
        <div className="absolute -bottom-6 -right-3 rounded-2xl border border-[#E2C792]/30 bg-[#0A0A0A]/90 px-6 py-5 backdrop-blur-xl md:-right-8">
          <p className="font-display text-3xl font-extrabold text-[#E2C792]">7 dni</p>
          <p className="mt-1 text-xs font-medium tracking-wide text-white/60">
            w tygodniu do Twojej dyspozycji
          </p>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, x: 40 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      >
        <p className="mb-4 font-display text-xs font-semibold tracking-[0.3em] text-[#E2C792]">
          O NAS
        </p>
        <h2 className="font-display text-4xl font-extrabold tracking-tight text-white sm:text-5xl">
          Zawozimy tam, gdzie <span className="text-[#E2C792]">musisz być</span>
        </h2>
        <div className="mt-7 space-y-5 text-base leading-relaxed text-white/65">
          <p>
            TRANSPORT OSÓB to firma przewozowa, która traktuje każdego pasażera
            indywidualnie. Obsługujemy przejazdy lokalne i krajowe — od krótkiego
            dojazdu do lekarza, przez wesela i imprezy, po transfery na lotnisko
            i wyjazdy do sanatorium.
          </p>
          <p>
            Wystarczy jeden telefon albo SMS. Ustalamy
            godzinę, miejsce odbioru i wszystkie szczegóły — a Ty masz pewność,
            że kierowca będzie na czas.
          </p>
        </div>
        <a
          href={getSmsHref()}
          onClick={handleSmsClick}
          data-testid="about-sms-button"
          className="group mt-9 inline-flex items-center gap-3 font-display text-base font-bold tracking-wide text-[#E2C792]"
        >
          NAPISZ SMS
          <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1.5" strokeWidth={2.5} />
        </a>
      </motion.div>
    </div>
  </section>
);
